var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1775",
    "data-name": "Rectangle 1775",
    width: 19,
    height: 24,
    transform: "translate(0 -0.074)",
    fill: "#242c32"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10362",
    "data-name": "Group 10362",
    transform: "translate(0.006 0.074)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3329",
    "data-name": "Group 3329",
    transform: "translate(-0.006 0.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11131",
    "data-name": "Path 11131",
    d: "M9.5,0A9.5,9.5,0,0,0,0,9.4C0,15.911,8.372,23.151,8.725,23.46a1.193,1.193,0,0,0,1.545,0C10.685,23.151,19,15.911,19,9.4A9.5,9.5,0,0,0,9.5,0m0,20.956C7.513,19.07,2.374,13.832,2.374,9.4a7.123,7.123,0,1,1,14.247,0c0,4.391-5.138,9.666-7.123,11.551",
    transform: "translate(0.004 -0.001)",
    fill: "#242c32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11132",
    "data-name": "Path 11132",
    d: "M7.53,3a4.155,4.155,0,1,0,4.155,4.155A4.157,4.157,0,0,0,7.53,3m0,5.936A1.781,1.781,0,1,1,9.311,7.155,1.782,1.782,0,0,1,7.53,8.936",
    transform: "translate(1.972 1.748)",
    fill: "#242c32"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location_icon.1ef757f3e19a8d849e4cb3229174b822.svg";
export { ForwardRef as ReactComponent };